import extend from 'extend'
import token from '@/common/services/token'
import moment from 'moment-timezone'
import _ from 'underscore'
import ajax from '@/common/services/ajax'

const initInput = () => {
  return {
    period_date: moment().format('YYYY-MM-DD'),
    measurement: {
      method: null,
      width: 1000,
      height: 1000,
      depth: 1000
    },
    osb: {
      top: null,
      side: null,
      bottom: null
    },
    edge_group: {
      top_side: null,
      side_side: null,
      bottom_side: null,
      extension: null,
      support: null
    },
    option: {
      clamp: null,
      clamp_pitch_input: false,
      clamp_pitch: 0,
      clog: null,
      clog_num: 0,
      clog_clearance: 30,
      clog_w_blocks: 0,
      clog_d_blocks: 0,
      clog_deck_direction: null,
      side_support: null,
      bottom_support: null,
      buckle: null,
      buckle_num: 0,
      belt: null,
      stamps: [],
      faces: {
        top: true,
        side: true,
        bottom: true
      }
    },
    overview: {
      quantity: 1,
      item_name: '',
      description: '',
      comment: '',
      cost_rate: -1,
      stack: false
    },
    specials: [],
    appendices: [],
    override: {
      is_price_override: false,
      overridden_price: 0
    }
  }
}

const initTrial = () => {
  return {
    token: null,
    input: initInput(),
    m3: {
      fixed_cost: 0
    },
    summary: {
      fixed_amount: 0,
      fixed_cost_rate: 0,
      fixed_price: 0
    },
    image: null
  }
}

const initPrepare = () => {
  return {
    order_date: moment().format('YYYY-MM-DD')
  }
}

const initSummary = () => {
  return {
    input_date: moment().format('YYYY-MM-DD'),
    seller: null,
    inputter: null,
    customer: null,
    house_company: {},
    terms: '別途御相談',
    place: '貴社',
    condition: '通常通り',
    expiration: '１ヶ月',
    message: '※木箱の詳細は２枚目以降の仕様表をご確認ください。',
    delivery_fee: 0,
    discount: 0
  }
}

const initState = () => {
  return {
    currentTab: 'prepare',
    progressing: false,
    writeBackToken: null,
    input: initInput(),
    trial: initTrial(),
    token: token.publishToken(),
    prepare: initPrepare(),
    boxes: [],
    summary: initSummary(),
    quotations: [],
    entry_quotation: null
  }
}

export default {
  namespaced: true,
  state () {
    return initState()
  },
  getters: {
    currentTab (state) {
      return state.currentTab
    },
    isNewOrder (state, getters, rootState) {
      return !rootState.route.params.token
    },
    progressing (state) {
      return state.progressing
    },
    input (state) {
      return state.input
    },
    hasTrial (state) {
      return !!state.trial.token
    },
    trial (state) {
      return state.trial
    },
    trialOverride (state) {
      return state.trial.input.override
    },
    trialSummary (state) {
      return state.trial.summary
    },
    order (state) {
      return {
        token: state.token,
        prepare: state.prepare,
        boxes: state.boxes,
        summary: state.summary,
        quotations: state.quotations,
        entry_quotation: state.entry_quotation
      }
    },
    prepare (state) {
      return state.prepare
    },
    boxes (state) {
      return state.boxes
    },
    getBox: state => index => {
      return state.boxes[index]
    },
    totalRows (state) {
      let count = 0
      _.each(state.boxes, function (box) {
        count += 1 + box.input.appendices.length
      })
      count += parseInt(state.summary.discount, 10) !== 0 ? 1 : 0
      return count
    },
    isListEmpty (state) {
      return state.boxes.length === 0
    },
    summary (state) {
      return state.summary
    },
    quotations (state) {
      return state.quotations
    },
    writeBackToken (state) {
      return state.writeBackToken
    },
    writeBackIndex (state) {
      if (state.writeBackToken === null) {
        return -1
      }
      return _.findIndex(state.boxes, box => box.token === state.writeBackToken)
    }
  },
  mutations: {
    setCurrentTab (state, currentTab) {
      state.currentTab = currentTab
    },
    initializeOrder (state) {
      Object.assign(state, initState())
    },
    setProgress (state, progress) {
      state.progressing = progress
    },
    setInput (state, input) {
      state.input = extend(true, state.input, input)
    },
    replaceInput (state, input) {
      state.writeBackToken = null
      state.input = extend(true, {}, input)
      state.input.period_date = state.prepare.order_date
      state.input.overview.description = ''
      state.input.overview.comment = ''
      state.input.override = {
        is_price_override: false,
        overridden_price: 0
      }
    },
    reEdit (state, { input, token }) {
      state.writeBackToken = token
      state.input = extend(true, {}, input)
      state.input.override = {
        is_price_override: false,
        overridden_price: 0
      }
    },
    addInputSpecial (state) {
      state.input.specials.push({
        title: '',
        amount: 0
      })
    },
    setInputSpecial (state, { index, special }) {
      state.input.specials.splice(
        index,
        1,
        extend(true, state.input.specials[index], special)
      )
    },
    removeInputSpecial (state, index) {
      state.input.specials.splice(index, 1)
    },
    addInputAppendix (state) {
      state.input.appendices.push({
        title: '',
        quantity: 1,
        unit_cost: 0,
        amount: 0,
        description: '',
        unit: {
          id: 1,
          name: '式'
        }
      })
    },
    setInputAppendix (state, { index, appendix }) {
      state.input.appendices.splice(
        index,
        1,
        extend(true, state.input.appendices[index], appendix)
      )
      state.input.appendices[index].amount =
        parseInt(state.input.appendices[index].quantity, 10) *
        parseInt(state.input.appendices[index].unit_cost, 10)
    },
    removeInputAppendix (state, index) {
      state.input.appendices.splice(index, 1)
    },
    setInputStamps (state, stamps) {
      // NOTE ここでソートするとEventが無限ループする。
      state.input.option.stamps = stamps
    },
    setTrial (state, trial) {
      Object.assign(state.trial, trial)
    },
    setTrialOverride (state, override) {
      state.trial.input.override = extend(
        true,
        state.trial.input.override,
        override
      )
    },
    setTrialOverview (state, overview) {
      state.trial.input.overview = extend(
        true,
        state.trial.input.overview,
        overview
      )
    },
    setTrialSummary (state, summary) {
      state.trial.summary = extend(true, state.trial.summary, summary)
    },
    setTrialM3 (state, m3) {
      state.trial.m3 = extend(true, state.trial.m3, m3)
    },
    clearTrial (state) {
      state.trial = initTrial()
      state.writeBackToken = null
    },
    setPrepare (state, prepare) {
      state.prepare = extend(true, state.prepare, prepare)
      state.input.period_date = state.prepare.order_date
    },
    clearPrepare (state) {
      state.prepare = initPrepare()
      state.input.period_date = state.prepare.order_date
    },
    setOrder (state, order) {
      state.token = order.token
      state.prepare = order.prepare
      state.boxes = order.boxes
      state.summary = order.summary
      state.quotations = order.quotations
      state.entry_quotation = order.entry_quotation
    },
    pushTrialToList (state) {
      if (state.writeBackToken === null) {
        state.boxes.push(Object.assign({}, state.trial))
        return
      }
      const index = _.findIndex(
        state.boxes,
        box => box.token === state.writeBackToken
      )
      if (index < 0) {
        console.warn('Invalid write back token. Add as new box.')
        state.boxes.push(Object.assign({}, state.trial))
        state.writeBackToken = null
        return
      }
      state.boxes.splice(index, 1, Object.assign({}, state.trial))
      state.writeBackToken = null
    },
    setBoxes (state, boxes) {
      state.boxes = boxes
    },
    clearBoxes (state) {
      state.boxes = []
    },
    removeBox (state, index) {
      state.boxes.splice(index, 1)
    },
    setSummary (state, summary) {
      state.summary = extend(true, state.summary, summary)
    },
    clearSummary (state) {
      state.summary = initSummary()
    },
    clearQuotations (state) {
      state.quotations = []
    }
  },
  actions: {
    activateTab ({ commit, state }, activeTab) {
      if (state.input.overview.cost_rate < 0) {
        ajax.get(`order/default_rate?period_date=${state.input.period_date}`, { loading: false }).then(function (response) {
          commit('setInput', {'overview': {'cost_rate': response.data.cost_rate}})
        })
      }
      commit('setCurrentTab', activeTab)
    },
    initializeOrder ({ commit }) {
      commit('initializeOrder')
    },
    startProgress ({ commit }) {
      commit('setProgress', true)
    },
    stopProgress ({ commit }) {
      commit('setProgress', false)
    },
    setPrepare ({ commit }, prepare) {
      commit('setPrepare', prepare)
    },
    clearPrepare ({ commit }) {
      commit('clearPrepare')
    },
    setInput ({ commit }, input) {
      commit('setInput', input)
    },
    replaceInput ({ commit }, input) {
      commit('replaceInput', input)
    },
    addInputSpecial ({ commit }) {
      commit('addInputSpecial')
    },
    setInputSpecial ({ commit }, value) {
      commit('setInputSpecial', value)
    },
    removeInputSpecial ({ commit }, index) {
      commit('removeInputSpecial', index)
    },
    addInputAppendix ({ commit }) {
      commit('addInputAppendix')
    },
    setInputAppendix ({ commit }, value) {
      commit('setInputAppendix', value)
    },
    removeInputAppendix ({ commit }, index) {
      commit('removeInputAppendix', index)
    },
    setInputStamps ({ commit }, stamps) {
      commit('setInputStamps', stamps)
    },
    setTrial ({ commit }, trial) {
      commit('setTrial', trial)
    },
    setTrialOverride ({ commit }, override) {
      commit('setTrialOverride', override)
    },
    setTrialOverview ({ commit }, overview) {
      commit('setTrialOverview', overview)
    },
    setTrialSummary ({ commit }, summary) {
      commit('setTrialSummary', summary)
    },
    setTrialM3 ({ commit }, m3) {
      commit('setTrialM3', m3)
    },
    clearTrial ({ commit }) {
      commit('clearTrial')
    },
    setOrder ({ commit }, order) {
      commit('setOrder', order)
    },
    pushTrialToList ({ commit }) {
      commit('pushTrialToList')
    },
    setBoxes ({ commit }, boxes) {
      commit('setBoxes', boxes)
    },
    clearBoxes ({ commit }) {
      commit('clearBoxes')
    },
    removeBox ({ commit }, index) {
      commit('removeBox', index)
    },
    setSummary ({ commit }, summary) {
      commit('setSummary', summary)
    },
    clearSummary ({ commit }) {
      commit('clearSummary')
    },
    clearQuotations ({ commit }) {
      commit('clearQuotations')
    },
    reEdit ({ commit }, inputAndToken) {
      commit('reEdit', inputAndToken)
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/Order/store.js